module.exports = __webpack_public_path__ + "media/images/landing_page/digweddash4_mobile-3337eb116ff11814de26b398f5d36b22.webp";